import { render } from "./Facebook.vue?vue&type=template&id=d6df7044"
const script = {}
script.render = render

export default script